import * as colors from '@/assets/styles/variables.module.scss';

export const STATUS_ICON_INFO = 'STATUS_ICON_INFO';
export const STATUS_ICON_INFO_O = 'STATUS_ICON_INFO_O';
export const STATUS_ICON_DOT = 'STATUS_ICON_DOT';
export const STATUS_ICON_PLAY = 'STATUS_ICON_PLAY';
export const STATUS_ICON_RUN = 'STATUS_ICON_RUN';
export const STATUS_ICON_LOADING = 'STATUS_ICON_LOADING';
export const STATUS_ICON_PAUSE = 'STATUS_ICON_PAUSE';
export const STATUS_ICON_TIMES = 'STATUS_ICON_TIMES';
export const STATUS_ICON_TIMES_O = 'STATUS_ICON_TIMES_O';
export const STATUS_ICON_STOP = 'STATUS_ICON_STOP';
export const STATUS_ICON_CHECK = 'STATUS_ICON_CHECK';
export const STATUS_ICON_CHECK_O = 'STATUS_ICON_CHECK_O';
export const STATUS_ICON_DISABLED = 'STATUS_ICON_DISABLED';
export const STATUS_ICON_BLOCKED = 'STATUS_ICON_BLOCKED';
export const STATUS_ICON_WARNING = 'STATUS_ICON_WARNING';
export const STATUS_ICON_WARNING_O = 'STATUS_ICON_WARNING_O';
export const STATUS_ICON_MAINTENANCE = 'STATUS_ICON_MAINTENANCE';
export const STATUS_ICON_STORAGE_NODE_MAINTENANCE = 'STATUS_ICON_STORAGE_NODE_MAINTENANCE';
export const STATE_ICON_RUN = 'STATE_ICON_RUN';
export const STATE_ICON_PAUSE = 'STATE_ICON_PAUSE';
export const STATE_ICON_STOP = 'STATE_ICON_STOP';
export const STATUS_ICON_INACTIVE = 'STATUS_ICON_INACTIVE';
export const STATE_ICON_ENABLED = 'STATE_ICON_ENABLED';
export const STATE_ICON_DISABLED = 'STATE_ICON_DISABLED';
export const STATUS_ICON_CLOCK = 'STATUS_ICON_CLOCK';
export const STATUS_ICON_INSTALL_READY = 'STATUS_ICON_INSTALL_READY';
export const STATE_ICON_UNASSIGNED = 'STATE_ICON_UNASSIGNED';
export const STATE_ICON_UNAVAILABLE = 'STATE_ICON_UNAVAILABLE';
export const STATUS_ICON_BAN = 'STATUS_ICON_BAN';
export const STATUS_ICON_PENDING = 'STATUS_ICON_PENDING';

export const STATUS_COLOR_PRIMARY = colors.avBrandPrimary;
export const STATUS_COLOR_PRIMARY_LIGHT = colors.avBrandLight;
export const STATUS_COLOR_BRAND_SECONDARY = colors.avBrandSecondary;
export const STATUS_COLOR_WARNING = colors.avFixedWarning;
export const STATUS_COLOR_WARNING_O = colors.avFixedCritical;
export const STATUS_COLOR_CRITICAL = colors.avFixedDanger;
export const STATUS_COLOR_GREEN = colors.avFixedSuccess;
export const STATUS_COLOR_GRAY = colors.avFixedLightest;
export const STATUS_COLOR_GRAY_DARK = colors.avFixedLight;
export const STATUS_COLOR_INFO = colors.avFixedInfo;

export const STATUSES_ICONS_MAPPING = {
  [STATUS_ICON_CLOCK]: {
    name: 'clock',
    color: STATUS_COLOR_PRIMARY_LIGHT
  },
  [STATUS_ICON_INFO_O]: {
    name: 'info-circle-o',
    color: STATUS_COLOR_PRIMARY
  },
  [STATUS_ICON_INFO]: {
    name: 'info-circle',
    color: STATUS_COLOR_PRIMARY
  },
  [STATUS_ICON_DOT]: {
    name: '',
    color: STATUS_COLOR_GRAY
  },
  [STATUS_ICON_PLAY]: {
    name: 'play-o',
    color: STATUS_COLOR_GREEN
  },
  [STATUS_ICON_RUN]: {
    name: 'run-circle',
    color: STATUS_COLOR_PRIMARY
  },
  [STATUS_ICON_LOADING]: {
    name: 'spinner',
    color: STATUS_COLOR_PRIMARY
  },
  [STATUS_ICON_PAUSE]: {
    name: 'suspend-o',
    color: STATUS_COLOR_GRAY
  },
  [STATUS_ICON_TIMES]: {
    name: 'times',
    color: STATUS_COLOR_CRITICAL
  },
  [STATUS_ICON_TIMES_O]: {
    name: 'times-circle',
    color: STATUS_COLOR_CRITICAL
  },
  [STATUS_ICON_STOP]: {
    name: 'stop-o',
    color: STATUS_COLOR_GRAY
  },
  [STATUS_ICON_CHECK]: {
    name: 'check',
    color: STATUS_COLOR_GREEN
  },
  [STATUS_ICON_CHECK_O]: {
    name: 'check-circle',
    color: STATUS_COLOR_GREEN
  },
  [STATUS_ICON_DISABLED]: {
    name: 'ban-o',
    color: STATUS_COLOR_CRITICAL
  },
  [STATUS_ICON_INACTIVE]: {
    name: 'ban-o',
    color: STATUS_COLOR_PRIMARY_LIGHT
  },
  [STATUS_ICON_BAN]: {
    name: 'ban',
    color: STATUS_COLOR_PRIMARY_LIGHT
  },
  [STATUS_ICON_BLOCKED]: {
    name: 'minus-circle',
    color: STATUS_COLOR_CRITICAL
  },
  [STATUS_ICON_WARNING]: {
    name: 'exclamation-triangle',
    color: STATUS_COLOR_WARNING
  },
  [STATUS_ICON_WARNING_O]: {
    name: 'exclamation-circle',
    color: STATUS_COLOR_WARNING_O
  },
  [STATUS_ICON_MAINTENANCE]: {
    name: 'maintenance-o',
    color: STATUS_COLOR_WARNING
  },
  [STATUS_ICON_INSTALL_READY]: {
    name: 'install',
    color: STATUS_COLOR_PRIMARY
  },
  [STATE_ICON_RUN]: {
    name: 'run-circle',
    color: STATUS_COLOR_GREEN
  },
  [STATE_ICON_PAUSE]: {
    name: 'paused-circle',
    color: STATUS_COLOR_PRIMARY
  },
  [STATE_ICON_STOP]: {
    name: 'stopped-circle',
    color: STATUS_COLOR_GRAY_DARK
  },
  [STATE_ICON_ENABLED]: {
    name: '',
    color: STATUS_COLOR_GREEN
  },
  [STATE_ICON_DISABLED]: {
    name: '',
    color: STATUS_COLOR_GRAY
  },
  [STATE_ICON_UNASSIGNED]: {
    name: 'help-circle',
    color: STATUS_COLOR_PRIMARY_LIGHT
  },
  [STATE_ICON_UNAVAILABLE]: {
    name: 'ban',
    color: STATUS_COLOR_PRIMARY_LIGHT
  },
  [STATUS_ICON_PENDING]: {
    name: 'clr-pending--16',
    color: STATUS_COLOR_PRIMARY_LIGHT
  }
};
